import React, { useState, useEffect, useCallback, useContext, useMemo } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Col, Row, Container, Button } from "react-bootstrap";
import { setInitied } from '../redux/actions/profileActions';
import { getCDNImage } from '../globals';
import Screen from '../components/Screen';
import { T, TF } from "react-translator-component";
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { useNavigate } from 'react-router-dom';
import { isAlvarezArguellez, isBelAir, isCostaGalana, isHostz, isHostzArosa, isHostzBecozy, isHostzBetaHouse, isHostzBlackSummit, isHostzCozy, isHostzMyde, isHostzSanCarlo, isHostzSteiners, isHostzSwissstay, isKalmStay, isOffgrid, isSimplex } from "../components/CheckIn/hotelConditions";

const Welcome = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { data: hotel, getUrlPath } = useContext(HotelContext)
  const { Room, stayConfirmInit } = useContext(UserContext)

  useEffect(() => {
    if (isKalmStay(hotel?.id) || isAlvarezArguellez(hotel?.id)) {
      goInto();
      return;
    } else {
      setLoading(false);
    }
  }, []);

  const goInto = useCallback(() => {
    stayConfirmInit();
    setTimeout(() => {
      navigate(getUrlPath('/checkin/status'), { replace: true })
    }, 100);
  }, []);

  const welcomeSubtitle = useMemo(() => {
    let res = T('welcome.subtitle');
    if (isOffgrid(hotel.id)) {
      res = T('welcome.subtitle-offgrid');
    }
    return res;
  }, [hotel?.id]);

  const welcomeText = useMemo(() => {
    let res = T('welcome.text');

    if (isCostaGalana(hotel.id)) {
      res = T('welcome.text-costa-galana');
    }
    if (isBelAir(hotel.id)) {
      res = T('welcome.text-belair');
    }
    if (isHostzBecozy(hotel.id)) {
      res = T('welcome.text-hostz-becozy');
    }
    if (isHostzSanCarlo(hotel.id)) {
      res = T('welcome.text-hostz-san-carlo');
    }
    if (isHostzBlackSummit(hotel.id)) {
      res = T('welcome.text-hostz-blacksummit');
    }
    if (isHostzBetaHouse(hotel.id) || isHostzCozy(hotel.id)) {
      res = T('welcome.text-hostz-betahouse');
    }

    if (isHostzMyde(hotel.id)) {
      res = T('welcome.text-hostz-themyde');
    }
    if (isHostzArosa(hotel.id)) {
      res = T('welcome.text-hostz-arosa');
    }
    if (isHostzSwissstay(hotel.id)) {
      res = T('welcome.text-hostz-swissstay');
    }
    if (isHostzSteiners(hotel.id)) {
      res = T('welcome.text-hostz-steiners');
    }
    if (isOffgrid(hotel.id)) {
      res = T('welcome.text-offgrid');
    }
    if (isSimplex(hotel.id)) {
      res = T('welcome.text-simplex');
    }

    return res;
  }, [hotel?.id]);

  const welcomeRoom = useMemo(() => {
    let res = T('welcome.room');
    if (isHostzBlackSummit(hotel?.id)) {
      res = T('welcome.room_bs')
    }
    if (isOffgrid(hotel?.id)) {
      res = T('welcome.room-offgrid')
    }
    return res;
  }, [hotel?.id]);

  const welcomeFooter = useMemo(() => {
    let res = T('welcome.footer');

    if (isBelAir(hotel.id)) {
      res = T('welcome.footer-belair');
    }

    if (isHostz(hotel.id)) {
      res = T('welcome.footer-hostz');
    }

    if (isHostzMyde(hotel.id)) {
      res = "";
    }
    if (isHostzArosa(hotel.id)) {
      res = "";
    }
    if (isHostzSwissstay(hotel.id)) {
      res = "";
    }
    if (isHostzSteiners(hotel.id)) {
      res = "";
    }
    if (isSimplex(hotel.id)) {
      res = "";
    }
    if (isOffgrid(hotel.id)) {
      res = T('welcome.footer-offgrid');
    }
    if (isHostzBetaHouse(hotel.id) || isHostzCozy(hotel.id)) {
      res = T('welcome.footer-hostz-betahouse');
    }

    return res;
  }, [hotel?.id]);

  // const { user } = useSelector(state => state.authReducer);
  // useEffect(() => {
  //   setTimeout(() => {

  //   }, 1500);
  // }, [])
  if (loading || !Room) return <div className="text-center mt-4 mb-4" style={{ opacity: 0.3 }}>
    <div className="spinner-border" role="status"></div>
  </div>;

  return <Screen
    section={'welcome'}
    title={'Check-In'}
    description={welcomeSubtitle}
  >
    {/* // // <Row className="page-header text-center mb-0">
        // //   <Col>
        // //       <img src={getCDNImage(hotel.logo)} style={{ maxWidth: 90, maxHeight: 90, marginBottom: 20 }} />
        // //       <h4 className="text-center">{T('welcome.title')}</h4>
        // //       {/* <p className="text-center">{T('welcome.subtitle')}</p> 
        // //   </Col>
        // // </Row>
        // <Row className="page-body">
        //     <Col> */}
    <p className="general-text-sm text-center mt-2">
      {welcomeText}
    </p>
    <div className="text-center welcome-code" style={{ background: "white", border: "1px solid #EEE", borderRadius: 10, padding: "10px 20px" }}>
      <div className="general-text-sm text-center mt-2 mb-0">
        {welcomeRoom}
      </div>
      <h3 className="room-code">{Room?.code ?? "-"}</h3>
    </div>
    <p className="general-text-sm text-center mt-4">
      {welcomeFooter}
    </p>
    {/* </Col>
      // </Row> */}
    <div className="footer-container">
      <Button
        size={'lg'}
        variant={'primary'}
        type={'button'}
        block={true}
        onClick={() => goInto()}>{T('welcome.start')}</Button>
    </div>
    {/* </Container> */}
  </Screen>;
}

export default Welcome;